(function () {
  'use strict';

  angular
    .module('web2print')
    .directive('zipcodeCityAutocomplete', zipcodeCityAutocomplete);

  /* @ngInject */

  function zipcodeCityAutocomplete ($http) {
    const directive = {
      restrict: 'A',
      require: 'ngModel',
      link: link,
    };

    function link (scope, element, attrs, ngModel) {
      attrs.$observe('zipcodeCityAutocomplete', function (zipcode) {
        if (zipcode.length === 5) {
          // Uses Google Geocoding API
          /*$http({
					    method: 'GET',
					    url: 'https://maps.googleapis.com/maps/api/geocode/json?components=country:SE|postal_code:' + zipcode + '&key=KEYHERE'})
					    .then(function successCallback(response) {
					        if (response.data.status == 'OK'){
					            ngModel.$setViewValue(getCity(response.data.results[0].address_components));
					            ngModel.$render();
					            ngModel.$setValidity('invalidZipCode', true);
					        } else {
					            ngModel.$setValidity('invalidZipCode', false);
					        }
					    })*/
        } else {
          ngModel.$setViewValue('');
          ngModel.$setValidity('invalidZipCode', false);
          ngModel.$render();
        }
      });
    }

    return directive;
  }
})();
